import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const AddDetailsOfResearchSubmittedForAwardFiveYears = createAsyncThunk(
  "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/AddDetailsOfResearchSubmittedForAwardFiveYears",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/AddDetailsOfResearchSubmittedForAwardFiveYears",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateDetailsOfResearchSubmittedForAwardFiveYears =
  createAsyncThunk(
    "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/UpdateDetailsOfResearchSubmittedForAwardFiveYears",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient("application/json");
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/UpdateDetailsOfResearchSubmittedForAwardFiveYears",
          parameters
        );

        const data = response.data; // Assuming response has a "data" field
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const DeleteDetailsOfResearchSubmittedForAwardFiveYears =
  createAsyncThunk(
    "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/DeleteDetailsOfResearchSubmittedForAwardFiveYears",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient("application/json");
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/DeleteDetailsOfResearchSubmittedForAwardFiveYears",
          parameters
        );

        const data = response.data; // Assuming response has a "data" field
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const GetOneDetailsOfResearchSubmittedForAwardFiveYears =
  createAsyncThunk(
    "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/GetOneDetailsOfResearchSubmittedForAwardFiveYears",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient("application/json");
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/GetOneDetailsOfResearchSubmittedForAwardFiveYears",
          parameters
        );

        const data = response.data.result; // Assuming response has a "data" field
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const SortingListDetailsOfResearchSubmittedForAwardLastFiveYears =
  createAsyncThunk(
    "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/SortingListDetailsOfResearchSubmittedForAwardLastFiveYears",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient("application/json");
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/SortingListDetailsOfResearchSubmittedForAwardLastFiveYears",
          parameters
        );

        const data = response.data; // Assuming response has a "data" field
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const DetailsResearchSubmittedForAward =
  createAsyncThunk(
    "SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/DetailsResearchSubmittedForAward",
    async (parameters, { rejectWithValue }) => {
      try {
        await initializeApiClient("application/json");
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/SC_NT_RA_DetailsOfResearchSubmittedForAwardLastFiveYears/DetailsResearchSubmittedForAward",
          parameters
        );

        const data = response.data; // Assuming response has a "data" field
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const DetailsOfResearchSubmittedForAwardLastFiveYears = createSlice({
  name: "DetailsOfResearchSubmittedForAwardLastFiveYears",
  initialState: {
    //------------- AddDetailsOfResearchSubmittedForAwardFiveYears---------------------
    AddDetailsOfResearchSubmittedForAwardFiveYears: {},
    loadingAddDetailsOfResearchSubmittedForAwardFiveYears: false,
    errorAddDetailsOfResearchSubmittedForAwardFiveYears: null,
    //------------- UpdateDetailsOfResearchSubmittedForAwardFiveYears ---------------------
    UpdateDetailsOfResearchSubmittedForAwardFiveYears: {},
    loadingUpdateDetailsOfResearchSubmittedForAwardFiveYears: false,
    errorUpdateDetailsOfResearchSubmittedForAwardFiveYears: null,
    //------------- DeleteDetailsOfResearchSubmittedForAwardFiveYears ---------------------
    DeleteDetailsOfResearchSubmittedForAwardFiveYears: {},
    loadingDeleteDetailsOfResearchSubmittedForAwardFiveYears: false,
    errorDeleteDetailsOfResearchSubmittedForAwardFiveYears: null,
    //------------- GetOneDetailsOfResearchSubmittedForAwardFiveYears ---------------------
    OneDetailsOfResearchSubmittedForAwardFiveYears: {},
    loadingOneDetailsOfResearchSubmittedForAwardFiveYears: false,
    errorOneDetailsOfResearchSubmittedForAwardFiveYears: null,

     SortingListDetailsOfResearchSubmittedForAwardLastFiveYears: {},
    loadingSortingListDetailsOfResearchSubmittedForAwardLastFiveYears: false,
    errorSortingListDetailsOfResearchSubmittedForAwardLastFiveYears: null,


    DetailsResearchSubmittedForAward: {},
    loadingDetailsResearchSubmittedForAward: false,
    errorDetailsResearchSubmittedForAward: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        AddDetailsOfResearchSubmittedForAwardFiveYears.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingAddDetailsOfResearchSubmittedForAwardFiveYears = true;
          state.AddDetailsOfResearchSubmittedForAwardFiveYears = action.payload;
          state.errorAddDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        AddDetailsOfResearchSubmittedForAwardFiveYears.fulfilled,
        (state, action) => {
          state.loadingAddDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.AddDetailsOfResearchSubmittedForAwardFiveYears = action.payload;
        }
      )
      .addCase(
        AddDetailsOfResearchSubmittedForAwardFiveYears.rejected,
        (state, action) => {
          state.loadingAddDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.AddDetailsOfResearchSubmittedForAwardFiveYears = action.payload;
        }
      );
    //------------------- UpdateDetailsOfResearchSubmittedForAwardFiveYears -----------------------------------
    builder
      .addCase(
        UpdateDetailsOfResearchSubmittedForAwardFiveYears.pending,
        (state, action) => {
          state.loadingUpdateDetailsOfResearchSubmittedForAwardFiveYears = true;
          state.UpdateDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
          state.errorUpdateDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        UpdateDetailsOfResearchSubmittedForAwardFiveYears.fulfilled,
        (state, action) => {
          state.loadingUpdateDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.UpdateDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
        }
      )
      .addCase(
        UpdateDetailsOfResearchSubmittedForAwardFiveYears.rejected,
        (state, action) => {
          state.loadingUpdateDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.errorUpdateDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
        }
      );
    //------------------- DeleteDetailsOfResearchSubmittedForAwardFiveYears -----------------------------------
    builder
      .addCase(
        DeleteDetailsOfResearchSubmittedForAwardFiveYears.pending,
        (state, action) => {
          state.loadingDeleteDetailsOfResearchSubmittedForAwardFiveYears = true;
          state.DeleteDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
          state.errorDeleteDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        DeleteDetailsOfResearchSubmittedForAwardFiveYears.fulfilled,
        (state, action) => {
          state.loadingDeleteDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.DeleteDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
        }
      )
      .addCase(
        DeleteDetailsOfResearchSubmittedForAwardFiveYears.rejected,
        (state, action) => {
          state.loadingDeleteDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.errorDeleteDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
        }
      );
    //------------------- GetOneDetailsOfResearchSubmittedForAwardFiveYears -----------------------------------
    builder
      .addCase(
        GetOneDetailsOfResearchSubmittedForAwardFiveYears.pending,
        (state, action) => {
          state.loadingOneDetailsOfResearchSubmittedForAwardFiveYears = true;
          state.OneDetailsOfResearchSubmittedForAwardFiveYears = action.payload;
          state.errorOneDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        GetOneDetailsOfResearchSubmittedForAwardFiveYears.fulfilled,
        (state, action) => {
          state.loadingOneDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.OneDetailsOfResearchSubmittedForAwardFiveYears = action.payload;
        }
      )
      .addCase(
        GetOneDetailsOfResearchSubmittedForAwardFiveYears.rejected,
        (state, action) => {
          state.loadingOneDetailsOfResearchSubmittedForAwardFiveYears = false;
          state.errorOneDetailsOfResearchSubmittedForAwardFiveYears =
            action.payload;
        }
      );

 builder
      .addCase(
        SortingListDetailsOfResearchSubmittedForAwardLastFiveYears.pending,
        (state, action) => {
          state.loadingSortingListDetailsOfResearchSubmittedForAwardLastFiveYears = true;
          state.SortingListDetailsOfResearchSubmittedForAwardLastFiveYears = action.payload;
          state.errorOneDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        SortingListDetailsOfResearchSubmittedForAwardLastFiveYears.fulfilled,
        (state, action) => {
          state.loadingSortingListDetailsOfResearchSubmittedForAwardLastFiveYears = false;
          state.SortingListDetailsOfResearchSubmittedForAwardLastFiveYears = action.payload;
        }
      )
      .addCase(
        SortingListDetailsOfResearchSubmittedForAwardLastFiveYears.rejected,
        (state, action) => {
          state.loadingSortingListDetailsOfResearchSubmittedForAwardLastFiveYears = false;
          state.errorSortingListDetailsOfResearchSubmittedForAwardLastFiveYears =
            action.payload;
        }
      );


      builder
      .addCase(
        DetailsResearchSubmittedForAward.pending,
        (state, action) => {
          state.loadingDetailsResearchSubmittedForAward = true;
          state.DetailsResearchSubmittedForAward = action.payload;
          state.errorOneDetailsOfResearchSubmittedForAwardFiveYears = null;
        }
      )
      .addCase(
        DetailsResearchSubmittedForAward.fulfilled,
        (state, action) => {
          state.loadingDetailsResearchSubmittedForAward = false;
          state.DetailsResearchSubmittedForAward = action.payload;
        }
      )
      .addCase(
        DetailsResearchSubmittedForAward.rejected,
        (state, action) => {
          state.loadingDetailsResearchSubmittedForAward = false;
          state.errorDetailsResearchSubmittedForAward =
            action.payload;
        }
      );

  },
});

export default DetailsOfResearchSubmittedForAwardLastFiveYears.reducer;
